import React from 'react';
import { toPercent } from '../lib/recoveryRolloutFormatters';

const RiskCard = ({ label, value, tone }) => (
  <div className="rounded-lg border border-slate-800 bg-slate-950/70 p-3">
    <p className="text-[11px] uppercase tracking-wide text-slate-500">{label}</p>
    <p className={`mt-1 text-sm font-semibold ${tone}`}>{value}</p>
  </div>
);

const RecoveryRiskMetricsPanel = ({ metrics }) => (
  <section className="rounded-xl border border-slate-800 bg-slate-900/70 p-4">
    <h3 className="mb-3 text-sm font-semibold text-slate-100">Risk Metrics</h3>
    <div className="grid gap-2 sm:grid-cols-2 xl:grid-cols-3">
      <RiskCard label="Fallback Rate" value={toPercent(metrics?.fallbackRate)} tone="text-red-300" />
      <RiskCard label="V2 Error Rate" value={toPercent(metrics?.v2ErrorRate)} tone="text-red-200" />
      <RiskCard label="Critical Mismatch" value={metrics?.criticalMismatchCount ?? 0} tone="text-amber-200" />
      <RiskCard label="Expected Divergence" value={toPercent(metrics?.expectedDivergenceRate)} tone="text-blue-200" />
      <RiskCard label="Flapping Suppression" value={metrics?.flappingSuppressionCount ?? 0} tone="text-cyan-200" />
      <RiskCard label="Cooldown Defer" value={metrics?.cooldownDeferCount ?? 0} tone="text-purple-200" />
    </div>
  </section>
);

export default RecoveryRiskMetricsPanel;
